<span class="clearfix"></span>

<app-dialog [visible]="(notificationService?.loading$ | async)?.showLoading" [modal]="true" [blockScroll]="true" [closeOnEscape]="false" [closable]="false" [resizable]="false" [draggable]="false">
    <div style="justify-content: center; align-items: center; padding: 12.5px 12.5px;">
        <mat-spinner mode='indeterminate' color='warn'></mat-spinner>
        {{(notificationService?.loading$ | async)?.loadingMessage | translate}}
    </div>
</app-dialog>